import { useForm } from 'react-hook-form';
import { ComponentProps } from 'lib/component-props';
import { GetStaticComponentProps, constants } from '@sitecore-jss/sitecore-jss-nextjs';
import { getAllStates, getAllContactFormStates } from '../../../GraphQL/queries/stateList.query';
import { getContactEmailDomainsListForContactInfo } from '../../../GraphQL/queries/contactEmailDomainsList.query';
import { getAllTimeZones } from '../../../GraphQL/queries/timeZoneList.query';
import { fetchConditionOfInterest } from '../../../GraphQL/queries/fetchConditionOfInterest.query';
import ContactInfoContextProvider from '../ContactInfoContextProvider';
import { ContactInfoFieldsInterface } from '../ContactInfo.types';
import { getDefaultTimeZone } from '../../../lib/utils/timeZoneHelpers';
import { useStoreContactInfoData } from '../useStoreContactInfoData';
import {
  formatAdultFormData,
  getTerritoryCountryCode,
  getTranslatedStateName,
} from '../../../transformers/contactInfo.transform';
import {
  updateAutoCompleteLocationInfo,
  updateContactInfo,
} from '../../../features/contactInfoSlice';
import {
  constructVirtualSiteData,
  prePopulateMegaScreenerDataForAdultForm,
  prePopulateSceeenerDataForAdultForm,
  updateConsents,
  validateSMSandIsMobile,
  prepopulateMyProfileForAdultForm,
  updateGender,
  constructConditionsOfInterest,
  callDapApiSendEmailAllDetailsAdult,
  constructCOIBasedOnKey,
  getCdpCondition,
  postDeduplicationAudit,
  handleReferralAudit,
  postLeads,
} from '../helper';
import useContactInfoHelper from '../../../lib/hooks/useContactInfoHelper';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import debounce from '@mui/utils/debounce';
import { ExtenedLayoutServiceContextInterface } from '../../../lib/type/Site';
import * as cdpService from '../../../services/CdpService';
import { CDP_EVENTS, JOURNEYS } from '../../../constants';
import { fetchNextPossiblePathAndData } from '../../../services/CdpService';
import { storeCDPData } from '../../../features/cdpDataSlice';
import {
  fetchProfileDetailsForCR,
  prePopulateEprContactDetails,
  savePatientDelegateDetailsToCDP,
} from '../../../lib/utils/axiosCDPFetcher';
import {
  ENROLLMENT_EXPIRY_TIME_FALLBACK,
  getCookie,
  getCookieExpiryTime,
  getOrCreateEnrollmentId,
  getEnrollmentId,
} from '../../../lib/utils/enrollmentUtil';
import { JOURNEY_STEP } from '../../../constants';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSelector } from 'react-redux';
import { RootState, store } from '../../../store/store';
import { post } from '../../../lib/utils/axiosFetcher';
import { getQuery, getRespectiveCOIList, removeTrailingSlash } from '../../../lib/utils/common';
import { setCookie } from 'cookies-next';
import { checkReturningUser } from '../../../services/ReturningUserService';
import { addpotentialParticipantId } from '../../../features/potentialParticipantDetailsSlice';
import { PatientType } from '../../../lib/type/userJourney.types';
import { useMutation } from 'react-query';
import { trackEvent } from '../../../lib/utils/gtmService';
import isEmpty from 'lodash/isEmpty';
import { setSelectedCOIList } from '../../../features/registrationSlice';
import { setAuthentication } from '../../../features/authSlice';
import { setProfileData } from '../../../features/crProfileSlice';
import {
  getCommunities,
  getStringValFromArray,
  getStringValFromArrayForCDP,
} from '../../../services/RegisterUserService';
import dynamic from 'next/dynamic';
import axios from 'axios';
import { DataOrigin, updateUCPMJobRecordsForCR } from '../../../lib/utils/ucpmHelper';
import { sendWelcomeSms, unblockUserSMS } from '../../../components/shared/Sms/helper';
import { getDialingCodeByISOCode } from '../../../lib/utils/dialingCodeList';
import { pickBy } from 'lodash';
import isClinicalTrialSource from '../../../lib/utils/sourceHelper';
import isClinicalTrialSite, {
  isDifferentBrowserResumeJourneyEnabled,
  isMegaScreenerStudy,
} from '../../../lib/utils/siteHelper';
import { contactFormFieldType, USER_TYPE } from '../constants';
import { geocodeFullAddress } from '../../../lib/utils/contactForm';

export type ContactListProps = ComponentProps & ContactInfoFieldsInterface;

const ContactInfo = dynamic(() => import('../ContactInfo'), {
  ssr: false,
});
const MAX_RETRY_COUNT = 3;
const MAX_EXPERIENCE_RETRY_COUNT = 4;

const AdultContactInfo = (props: ContactListProps): JSX.Element => {
  const {
    dispatch,
    executeRecaptcha,
    selectedLanguage,
    potentialParticipant_ID,
    potentialId,
    isRecapchaEnabled,
    timeZoneList,
    screenerOutput,
    prepopulateConfig,
    contactEmailDomainsList,
    reCaptchItem,
    geolocation,
    cdpState,
    siteSettingsId,
    setCustomErrorModal,
    showCustomErrorModal,
    setPatientExistModal,
    showPatientExistErrorModal,
    returningUserTimeInterval,
    returningUserTimeValue,
    setEmailSentModal,
    showEmailSentModal,
    ContactNumberField,
    ConsentsMedium,
    getInitialVlaueForIsMobile,
    userToggleableSmsFieldNames,
  } = useContactInfoHelper(props);
  const router = useRouter();
  const { query } = router;

  const { sitecoreContext } = useSitecoreContext();
  const siteSettings: any = sitecoreContext?.siteSettings;
  const isMegaScreenerSite = isMegaScreenerStudy(siteSettings);
  const tenantKey = isMegaScreenerSite
    ? getCookie('tenantKey') || ''
    : siteSettings?.tenantKey?.value || '';
  const isEnableGoogleRecaptcha = siteSettings?.EnableGoogleRecaptcha?.value || false;
  const journeyType = useSelector((state: RootState) => state?.cdpData?.journeyType);
  const cdpData = useSelector((state: RootState) => state?.cdpData);
  const screenerOutcomeParameter = useSelector(
    (state: RootState) => state.megaScreener?.screenerOutcomeParameter
  );
  const selectedPlace = useSelector((state: RootState) => state.selectedSite);
  const sitecoreFieldsForContactInfo = useSelector(
    (state: RootState) => state.contactInfoDetails.sitecoreFieldsForContactInfo
  );
  const selectedCOIList = useSelector(
    (state: RootState) => state.registrationDetails.selectedCOIList
  );
  const formatedCOIList = useSelector(
    (state: RootState) => state.contactInfoDetails.conditionOfIntrestList
  );
  const isAuthenticated: boolean = useSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );
  const stepNumber: number = useSelector((state: RootState) => state.contactInfoDetails.stepNumber);
  const stateList = useSelector((state: RootState) => state.contactInfoDetails.stateList);
  const consentPrepopulatedforTAEPR = useRef<any>(false);
  const updatePpidRef = useRef<any>(false);
  const [myProfileData, setMyProfileData] = useState<any>();
  const retuningUser = useRef<any | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const retryCount = useRef(0);
  const isCurrentResume = useRef<any>(false);
  const searchQueryData = useSelector((state: RootState) => state?.queryParams);

  const siteName = sitecoreContext?.site?.name;
  const removeQueryParamList = (siteSettings as any)?.RemoveQueryParamList?.value?.split('&');
  const retainQueryParamList = (siteSettings as any)?.RetainQueryParamList?.value?.split('&');
  const searchQueryDataCopy = { ...searchQueryData };
  const queryParamsData = pickBy(
    getQuery(searchQueryDataCopy, retainQueryParamList, removeQueryParamList),
    (value) => !!value?.length
  );
  const [isMounted, setIsMounted] = useState(false);
  const [isCRExistingUserState, setIsCRExistingUserState] = useState(false);
  const getFormDataDefaultValue = (existingValues: any) => {
    if (myProfileData) {
      return {
        UserTimeZone: getDefaultTimeZone(timeZoneList, existingValues),
        ...(isMegaScreenerSite
          ? prePopulateMegaScreenerDataForAdultForm(
              screenerOutcomeParameter,
              prepopulateConfig,
              existingValues,
              geolocation,
              sitecoreFieldsForContactInfo,
              cdpData,
              stateList
            )
          : prePopulateSceeenerDataForAdultForm(
              screenerOutput,
              prepopulateConfig,
              existingValues,
              geolocation,
              sitecoreFieldsForContactInfo,
              cdpData,
              stateList
            )),
        ...prepopulateMyProfileForAdultForm(myProfileData, existingValues),
      };
    } else {
      return {
        UserTimeZone: getDefaultTimeZone(timeZoneList, existingValues),
        isMobile: getInitialVlaueForIsMobile(existingValues),
        ...(isMegaScreenerSite
          ? prePopulateMegaScreenerDataForAdultForm(
              screenerOutcomeParameter,
              prepopulateConfig,
              existingValues,
              geolocation,
              sitecoreFieldsForContactInfo,
              cdpData,
              stateList
            )
          : prePopulateSceeenerDataForAdultForm(
              screenerOutput,
              prepopulateConfig,
              existingValues,
              geolocation,
              sitecoreFieldsForContactInfo,
              cdpData,
              stateList
            )),
      };
    }
  };

  const updateCurrentJourneyStepinCDP = async () => {
    const payload = {
      enrollmentId: getOrCreateEnrollmentId(),
      journeyStep: JOURNEY_STEP.CONTACT_INFO,
      journeyStatus: cdpState?.journeyStatus,
      isActiveEnrollment: '1',
    };

    if (potentialParticipant_ID) {
      const guestType = cdpState?.guestType || 'visitor';
      cdpService.updateCurrentJourneyInCDP(potentialParticipant_ID, guestType, payload);
    }
  };

  const prepopulateMyProfile = async () => {
    const authenticatedUserToken = sessionStorage.getItem('myProfileVerificationToken');
    if (authenticatedUserToken && isAuthenticated) {
      const response = await prePopulateEprContactDetails(authenticatedUserToken, tenantKey);
      if (response.data) {
        setMyProfileData(response.data);
      }
    }
  };

  const formHandlerObject = useForm({
    mode: 'all',
    defaultValues: async () => getFormDataDefaultValue({}),
  });

  const { watch, trigger, setError } = formHandlerObject;

  useEffect(() => {
    updateCurrentJourneyStepinCDP();
    prepopulateMyProfile();
    trackEvent(
      {
        event: 'Participant Type identified',
        participantType: PatientType.ADULT,
      },
      isClinicalTrialSite(siteName as string) ? true : false
    );
  }, []);

  useEffect(() => {
    const existingValues = formHandlerObject?.getValues();
    formHandlerObject.reset({ ...existingValues, ...getFormDataDefaultValue(existingValues) });
  }, [prepopulateConfig, sitecoreFieldsForContactInfo, myProfileData]);

  const populateExistingMyProfileConsents = async (consents: any) => {
    try {
      if (consents) {
        const formattedConsents = { ...consents };
        delete formattedConsents.combinedConsentAccepted;
        updateConsents('secondary', formattedConsents);
      }
    } catch (_e) {
      return;
    }
  };

  const populateMyProfileGender = async (genderValue: any) => {
    try {
      updateGender(genderValue);
    } catch (_e) {
      return;
    }
  };

  const populateConditionOfInterest = async (conditionsList: any) => {
    try {
      const response = constructConditionsOfInterest(conditionsList, formatedCOIList);
      if (response && response.length > 0) {
        dispatch(setSelectedCOIList(response));
      }
    } catch (_e) {
      return;
    }
  };

  useEffect(() => {
    if (myProfileData?.basicDetails?.gender) {
      populateMyProfileGender(myProfileData?.basicDetails?.gender);
    }
    if (myProfileData?.conditions) {
      populateConditionOfInterest(myProfileData?.conditions);
    }
  }, [myProfileData]);

  useEffect(() => {
    if (myProfileData?.basicDetails?.secondaryConsent) {
      setTimeout(() => {
        const isSecondaryConsentsLoaded: HTMLElement = document.querySelector(
          `input[name="SecondaryConsentMedium"]`
        ) as HTMLElement;
        if (isSecondaryConsentsLoaded && !consentPrepopulatedforTAEPR.current) {
          consentPrepopulatedforTAEPR.current = true;
          populateExistingMyProfileConsents(myProfileData?.basicDetails?.secondaryConsent);
        }
      }, 1000);
    }
  }, [myProfileData, stepNumber]);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    const screenerCondition =
      screenerOutput?.condition || cdpData?.condition || getCdpCondition(cdpData);
    if (screenerCondition && isClinicalTrialSource(siteSettings?.source?.fields?.name?.value)) {
      const conditionKeyDescription = screenerCondition.split(',');
      if (conditionKeyDescription?.length > 0) {
        const matchedCoiFromScreener = constructCOIBasedOnKey(
          conditionKeyDescription,
          formatedCOIList
        );
        if (myProfileData?.conditions && myProfileData?.conditions?.length > 0) {
          const myProfileCondition = myProfileData?.conditions;
          const seen = new Set();
          const mergedConditions = [
            ...new Set([
              ...myProfileCondition.filter((item: { sitecoreId: unknown }) => {
                if (seen.has(item?.sitecoreId)) {
                  return false;
                } else {
                  seen.add(item?.sitecoreId);
                  return true;
                }
              }),
              ...matchedCoiFromScreener.filter((item: { sitecoreId: unknown }) => {
                if (seen.has(item?.sitecoreId)) {
                  return false;
                } else {
                  seen.add(item?.sitecoreId);
                  return true;
                }
              }),
            ]),
          ];
          populateConditionOfInterest(mergedConditions);
        } else {
          populateConditionOfInterest(matchedCoiFromScreener);
        }
      }
    }
  }, [stepNumber, myProfileData, isMounted]);

  useEffect(() => {
    const debouncedCb = debounce(async (value: any, { name }) => {
      if (name === 'Email') {
        const isValid = await trigger(name);
        if (isValid) {
          await populateExistingUserConsents(value['Email']);
        }
      }
    }, 3000);

    const subscription = watch((v, n) => {
      debouncedCb(v, n);
      if (ConsentsMedium.length > 0) {
        validateSMSandIsMobile(
          v,
          trigger,
          setError,
          ContactNumberField,
          userToggleableSmsFieldNames
        );
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const updatePotentialParticipantId = async () => {
    try {
      const { data: response } = await post(
        `/Participant/UpdatePotentialParticipantId?potentialId=${potentialId}&potentialParticipantId=${getCookie(
          'bx_guest_ref'
        )}`
      );
      return response;
    } catch (_e) {}
  };

  const { mutate: updatePpId } = useMutation(
    'update-potential-participantId',
    updatePotentialParticipantId,
    {
      onSuccess: (_data) => {
        return _data;
      },
      onError: () => undefined,
    }
  );

  const updateUCPMJobRecords = async (isUserRegistered = false) => {
    try {
      //fetching CR siteSetting data
      const { data } = await axios.get(`/api/cr-context-data`);
      const siteSettings = data?.siteSettings;
      if ((siteSettings as any)?.enableUCPMIntegration?.value === false) {
        return;
      }
      return await updateUCPMJobRecordsForCR({
        otSponsorId: siteSettings?.otSponsorId?.value || '',
        parentSponsorMDMID: siteSettings?.parentSponsorMDMEntityId?.value || '',
        protocolMDMID: siteSettings?.parentSponsorMDMEntityId?.value || '',
        sponsor: siteSettings?.sponsorName?.value || '',
        iqviaSponsorId: siteSettings?.iqviaSponsorId?.value || '',
        dataOrigin: isUserRegistered ? DataOrigin.TA_CR_UPDATE : DataOrigin.TA_CR_REGISTRATION,
        UCPMStudyName: siteSettings?.studyName?.value || '',
        baseUrl: siteSettings?.baseUrl?.value || '',
      });
    } catch (_e) {}
  };

  const successCallbackRetry = async (data: any) => {
    const extensionData = {
      ContactFormSubmit: true,
      tenantKey: tenantKey,
    };
    cdpService.event(CDP_EVENTS.CONTACT_FORM_SUBMIT, extensionData);
    setTimeout(() => {
      const communityList = getCommunities(selectedCOIList);
      if (communityList && Array.isArray(communityList) && communityList.length > 0) {
        cdpService.event(CDP_EVENTS.ADD_COMMUNITY_ADULT, {
          communityName: Array.isArray(communityList)
            ? communityList.map((c) => c?.key || c?.name || '').join(',')
            : '',
        });
      }
    }, 5000);

    const { getValues } = formHandlerObject;
    const email = getValues('Email' as never);
    cdpService.identityEvent(email);
    dispatch(updateContactInfo(data));
    postLeads('ContactRegistration', getEnrollmentId() ?? undefined);

    const mailIdList = siteSettings?.sendMailingList?.value || '';
    const baseUrl = siteSettings?.baseUrl?.value || '';
    const cleanBaseUrl = removeTrailingSlash(baseUrl);
    const myProfileEndpoint = siteSettings?.myProfileItemUrl?.value?.href || '/manage-my-profile';
    const myProfileUrl = `${cleanBaseUrl}${myProfileEndpoint}`;
    const source = siteSettings?.source?.fields?.name?.value;
    const successCallbackData = data;
    try {
      //TODO: Journey status and enrollment id should be part of query params
      const cdpPayload = createCdpPayload(
        getValues,
        selectedLanguage,
        potentialId,
        tenantKey,
        cdpState,
        selectedPlace,
        selectedCOIList
      );
      // update existing record in db
      if (updatePpidRef.current) {
        updatePpId();
      }
      if (isClinicalTrialSource(siteSettings?.source?.fields?.name?.value)) {
        const authenticatedUserToken = sessionStorage.getItem('myProfileVerificationToken');
        const isUserRegistered = authenticatedUserToken && isAuthenticated ? true : false;
        dispatch(setAuthentication(true));
        updateUCPMJobRecords(isUserRegistered);
      }
      if (isClinicalTrialSource(source)) {
        callDapApiSendEmailAllDetailsAdult(
          cdpPayload,
          baseUrl,
          myProfileUrl,
          mailIdList,
          sitecoreContext?.siteSettingsId as any,
          sitecoreContext?.language as any,
          siteSettings?.source?.fields?.name?.value || 'CR'
        );
      }
      await postDeduplicationAudit(
        (sitecoreContext?.siteSettings as any)?.tenantKey?.value,
        getEnrollmentId() ?? undefined
      );
      await handleReferralAudit(false, siteName as string);
      await fetchProfileDataSeparateThread();
      // await
      //Exp api call to get next possible path
      try {
        //TODO: Need to change experience api one done from backend side, currently using old exp api
        const data = await fetchNextSteps();

        if (journeyType === JOURNEYS.JOURNEY_02 && data?.isVirtual) {
          await cdpService.updateIsVirtualinCDP(
            getCookie('bx_guest_ref'),
            cdpState?.guestType || 'visitor', // TODO: Confirm if it is Visitor or customer
            data?.isHumanAPIEnabledForVirtual,
            data?.sitesData,
            potentialId,
            potentialParticipant_ID,
            successCallbackData.patientId
          );

          const constructedSitesData = constructVirtualSiteData(
            data,
            tenantKey,
            getOrCreateEnrollmentId(),
            potentialId,
            potentialParticipant_ID,
            successCallbackData
          );

          const response = await post(
            '/SiteSelection/AddOrUpdatePatientSiteDetails',
            constructedSitesData
          );
          if (!response) {
            throw new Error('Error in updating Virtual Sites Data');
          }
        } else if (
          journeyType === JOURNEYS.JOURNEY_01 &&
          selectedPlace?.siteInfo?.isFovSchedulingEnabled
        ) {
          setCookie('journeyStep', JOURNEY_STEP.CONTACT_INFO, {
            expires: getCookieExpiryTime(
              siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
            ),
            secure: true,
          });

          trackEvent(
            {
              event: 'Completed Contact Form',
            },
            isClinicalTrialSite(siteName as string) ? true : false
          );
        }

        const goToNextStep = async () => {
          if (journeyType === JOURNEYS.JOURNEY_01) {
            const patientId = successCallbackData.patientId || '';
            const payload = {
              potentialId,
              baseUrl,
              isVirtual: 'false',
              patientId,
              enrollmentId: getOrCreateEnrollmentId(),
              tenantKey,
            };
            const response = post('/SiteSelection/AddOrUpdateIntegrationAttemptHistory', payload);
            if (!response) {
              throw new Error('Error in updating Virtual Sites Data');
            }
          }
          if (data?.nextStepUrl) {
            if (journeyType !== JOURNEYS.JOURNEY_01) {
              //TODO: this line need to remove once exp api is fully functional
              setCookie('journeyStep', JOURNEY_STEP.CONTACT_INFO, {
                expires: getCookieExpiryTime(
                  siteSettings?.resumeEnrollmentExpirationDays?.value ||
                    ENROLLMENT_EXPIRY_TIME_FALLBACK
                ),
                secure: true,
              });

              trackEvent(
                {
                  event: 'Completed Contact Form',
                },
                isClinicalTrialSite(siteName as string) ? true : false
              );
            }
            if (data?.nextStepUrl?.includes('siteselectionsuccess')) {
              const cookie_expiry = new Date();
              cookie_expiry.setDate(cookie_expiry.getDate() + 1);
              setCookie('allowSiteSelectionSuccess', true, {
                secure: true, // optional: ensures it's sent only over HTTPS
                expires: cookie_expiry,
              });
            }
            await router.push(
              {
                pathname: data?.nextStepUrl,
                query: getQuery(query, retainQueryParamList, removeQueryParamList),
              },
              undefined,
              { scroll: false } // 👈 prevent default scroll behavior
            );
            setTimeout(() => {
              window.scrollTo({ top: 0 });
            }, 100); // 100–300ms depending on transition/render time
          }
        };
        dispatch(storeCDPData(data));
        if (data?.nextStepUrl?.includes('siteselectionsuccess')) {
          const cookie_expiry = new Date();
          cookie_expiry.setDate(cookie_expiry.getDate() + 1);
          setCookie('allowSiteSelectionSuccess', true, {
            secure: true, // optional: ensures it's sent only over HTTPS
            expires: cookie_expiry,
          });
        }
        if (data?.nextStepUrl) {
          await goToNextStep();
        }
      } catch (_e) {
        //TODO: need to check if exp api fails what need to be done
        throw new Error('EXP API Failed');
      }
    } catch (_e) {
      throw _e;
    }
  };
  const successCallback = async ({ data }: any) => {
    setIsLoading(true);
    try {
      await successCallbackRetry(data);
    } catch (e: any) {}
    setIsLoading(false);
  };
  const callSendSmsEvent = async (data: any) => {
    try {
      const isSendSmsEnabled = siteSettings?.enableSmsSendFeature?.value;
      const isSmsConsented =
        data?.basicDetails?.secondaryConsent?.isSecondaryContactMediumSMS === 'Yes' ? true : false;
      if (
        isSendSmsEnabled &&
        isSmsConsented &&
        data?.basicDetails?.isMobile &&
        !data?.isWelcomeSmsSent &&
        (data?.migrated === undefined || data?.migrated === null) &&
        !isCRExistingUserState
      ) {
        const transactionalFromNumber = siteSettings?.transactionalFromNumber?.value;
        const pinPointProjectId = siteSettings?.pinPointProjectId?.value;
        const smsStudyName = siteSettings?.studyName?.value;
        const smsSponsor = siteSettings?.smsSponsor?.value;
        const sourceIdentifier = siteSettings?.smsSource?.fields?.name?.value;
        const countryCode = siteSettings?.countryCode?.value;
        const smsRootPath = sitecoreContext?.smsRootPath;
        const dialingCode = getDialingCodeByISOCode(selectedLanguage?.countryISO2);
        const smsExtensionData = {
          enrollmentId: '',
          smsType: 'Cr-Registration',
          transactionalFromNumber: transactionalFromNumber || '',
          pinPointProjectId: pinPointProjectId || '',
          smsStudyName: smsStudyName || '',
          smsSponsor: smsSponsor || '',
          sourceIdentifier: sourceIdentifier || '',
          countryCode: countryCode || '',
          smsRootPath: smsRootPath || '',
          mobileNumber: data?.basicDetails?.mobile
            ? `${dialingCode}${data?.basicDetails?.mobile}`
            : '',
          websiteName: sitecoreContext?.site?.name,
        };
        sendWelcomeSms(smsExtensionData);
      }
    } catch (_error) {}
  };

  const fetchProfileDataSeparateThread = async () => {
    setTimeout(async () => {
      const myProfileVerificationToken = sessionStorage.getItem('myProfileVerificationToken');

      if (myProfileVerificationToken) {
        try {
          const { data } = await fetchProfileDetailsForCR(myProfileVerificationToken);
          if (data) {
            dispatch(setProfileData(data));
            callSendSmsEvent(data);
          }
        } catch (_e) {
          throw new Error('Fetch profile details failed');
        }
      }
    }, 500);
  };

  const savedataToCdp = async (cdpPayload: any) => {
    while (retryCount.current < MAX_RETRY_COUNT) {
      try {
        retryCount.current += 1;
        await savePatientDelegateDetailsToCDP(
          `/api/contacts/AddUpdatePatientDetails/${getCookie('bx_guest_ref')}?guestType=${
            cdpState?.guestType || 'customer'
          }`,
          cdpPayload,
          siteSettings?.source?.fields?.name?.value
        );

        isCurrentResume.current = true;
        break; // Exit the loop if the retry succeeds
      } catch (e: any) {
        if (retryCount.current >= MAX_RETRY_COUNT) {
          throw new Error('savedataToCdp failed'); // Exit the loop if all retries fail
        }

        // Wait for 1 second before retrying
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    }
  };

  const fetchNextSteps = async () => {
    let retryAttempts = 0;
    const extensionData = {
      enrollmentId: getEnrollmentId() as any,
    };
    while (retryAttempts < MAX_EXPERIENCE_RETRY_COUNT) {
      try {
        retryAttempts += 1;
        const experienceId = process.env.NEXT_PUBLIC_CDP_EXPERIENCE_CONTACTINFO_ID;

        const data = await fetchNextPossiblePathAndData(
          experienceId,
          false,
          false,
          sitecoreContext?.site?.name,
          cdpData?.patientReferralStatus,
          cdpData?.isNoSitesConvenient
        );
        cdpService.event(CDP_EVENTS.CONTACTFORM_EXPERIENCE_SUCCESS, extensionData);
        return data; // Exit the loop if the retry succeeds
      } catch (e: any) {
        cdpService.event(CDP_EVENTS.CONTACTFORM_EXPERIENCE_FAILURE, extensionData);
        if (retryAttempts >= MAX_EXPERIENCE_RETRY_COUNT) {
          throw new Error('fetchNextSteps failed'); // Exit the loop if all retries fail
        }

        // Wait for 2 second before retrying
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    }
    setIsLoading(false);
  };

  const failureCallback = () => {
    setIsLoading(false);
    const extensionData = {
      ContactFormSubmit: false,
      tenantKey: tenantKey,
      journeyType: journeyType as string,
    };
    cdpService.event(CDP_EVENTS.CONTACT_FORM_ERROR, extensionData);
  };

  const getLatestAutoCompleteLocationInfo = () =>
    store.getState().contactInfoDetails.autoCompleteLocationInfo;

  const createCdpPayload = (
    getValues: () => any,
    selectedLanguage: any,
    potentialId: number,
    tenantKey: string,
    cdpState: any,
    selectedPlace: any,
    selectedCOIList: any
  ) => {
    const autoCompleteLocationInfo = getLatestAutoCompleteLocationInfo();
    const contactField = props.fields.items.find(
      (item) => item.fields.type.value === contactFormFieldType.CONTACT_TYPE
    );
    const contactNumberField = (contactField?.fields as any).contactFieldList.find(
      (item: any) => item?.fields?.key?.value === 'ContactNumber'
    );
    const isDefaultOptIn = (contactNumberField as { fields: { defaultOptIn?: { value: boolean } } })
      ?.fields?.defaultOptIn?.value;

    const formData = getValues();
    const payloadData = formatAdultFormData(
      formData,
      selectedLanguage,
      getCookie('bx_guest_ref'),
      potentialId,
      autoCompleteLocationInfo,
      tenantKey,
      getOrCreateEnrollmentId(),
      cdpState?.patientReferralStatus,
      selectedPlace,
      stateList,
      isDefaultOptIn
    );
    if (!isEmpty(selectedCOIList)) {
      const communityList = getCommunities(selectedCOIList);
      const communities = getStringValFromArrayForCDP(communityList, 'value', 'key');
      (payloadData as any)['communities'] = communities;
      (payloadData as any)['conditionOfInterest'] = getRespectiveCOIList(selectedCOIList, true);
    }
    const enrollmentId = getOrCreateEnrollmentId();
    return {
      ...payloadData,
      journeyStatusRequest: {
        enrollmentId: enrollmentId,
        journeyStep: JOURNEY_STEP.CONTACT_INFO,
        journeyStatus: '',
      },
    };
  };

  const { mutate } = useStoreContactInfoData(successCallback, failureCallback);

  const saveDataToDBAndCdp = async (data: any) => {
    let token: string | null = null;
    if (isEnableGoogleRecaptcha || isRecapchaEnabled) {
      if (!executeRecaptcha) {
        return false;
      }
      token = await executeRecaptcha('adult_form');
    }

    const contactInfoData = formatAdultFormData(
      data,
      selectedLanguage,
      getCookie('bx_guest_ref'),
      potentialId,
      getLatestAutoCompleteLocationInfo(),
      tenantKey,
      getOrCreateEnrollmentId(),
      cdpState?.patientReferralStatus,
      selectedPlace,
      stateList
    );
    const payload = {
      ...contactInfoData,
      token,
      contactFormSettingsId: reCaptchItem?.id,
      siteSettingsId,
    };
    if (!isEmpty(selectedCOIList)) {
      const communityList = getCommunities(selectedCOIList);
      const communities = getStringValFromArray(communityList, 'value', 'key');

      (payload as any)['conditionOfInterest'] = getRespectiveCOIList(selectedCOIList);
      (payload as any)['communities'] = communities;
    }
    const cdpPayload = createCdpPayload(
      formHandlerObject.getValues,
      selectedLanguage,
      potentialId,
      tenantKey,
      cdpState,
      selectedPlace,
      selectedCOIList
    );
    dispatch(updateContactInfo(payload));
    setIsLoading(true);
    // Call AddUpdatePatientDetails first
    try {
      const urlParams =
        (!isEmpty(queryParamsData) &&
          Object.entries(queryParamsData).map(([key, value]) => ({ key, value }))) ||
        [];
      if (urlParams && urlParams.length > 0) {
        (cdpPayload as any)['urlParams'] = urlParams;
      }

      await savedataToCdp(cdpPayload);
    } catch (error) {
      setIsLoading(false);
      throw new Error('AddUpdatePatientDetails failed');
    }

    unblockUserSMS(siteSettings, selectedLanguage?.countryISO2, data?.ContactNumber, cdpPayload);

    mutate({ url: '/Patient/Add', payload });
    return;
  };

  const populateExistingUserConsents = async (email: string) => {
    try {
      const { data: res } = await checkReturningUser(
        false,
        tenantKey,
        PatientType.ADULT,
        email,
        returningUserTimeInterval,
        returningUserTimeValue,
        '',
        '',
        '',
        false,
        true,
        sitecoreContext?.site?.name
      );
      retuningUser.current = res;
      if (res?.secondaryconsent?.combinedConsentAccepted === 'True') {
        if (Object.keys(res?.secondaryconsent).length) {
          updateConsents('combined', res?.secondaryconsent);
        }
      } else {
        if (Object.keys(res?.primaryconsent).length) {
          updateConsents('primary', res?.primaryconsent);
        }
        if (Object.keys(res?.secondaryconsent).length) {
          updateConsents('secondary', res?.secondaryconsent);
        }
      }
    } catch (_e) {
      retuningUser.current = null;
      return;
    }
  };

  const getLatLongFromAddressOnSubmit = async (
    address: string,
    city: string,
    state: string,
    zipcode: string,
    countryCode: string,
    language: string
  ): Promise<void> => {
    const geocoded = await geocodeFullAddress(
      address,
      city,
      state,
      zipcode,
      countryCode,
      language,
      siteSettings?.stateType
    );

    if (!geocoded) {
      return;
    }

    dispatch(
      updateAutoCompleteLocationInfo({
        [USER_TYPE.PATIENT]: {
          lat: geocoded.lat,
          lng: geocoded.lng,
          address: address?.trim() || '',
          city: city?.trim() || '',
          state: state || '',
          zipcode: zipcode?.trim() || '',
        },
      })
    );
  };

  const performReturningUserCheckOnSubmit = async (
    data: any,
    isResumeEmailCheck: boolean,
    isReturnCheck: boolean,
    isJourney3: boolean
  ) => {
    try {
      const email = data['Email'];
      setIsLoading(true);
      const { data: res } = await checkReturningUser(
        true,
        tenantKey,
        PatientType.ADULT,
        email,
        returningUserTimeInterval,
        returningUserTimeValue,
        '',
        '',
        '',
        isResumeEmailCheck,
        isReturnCheck,
        sitecoreContext?.site?.name,
        isJourney3
      );
      setIsLoading(false);
      retuningUser.current = res;
      // Keep isCRExistingUser in useState
      const isCRExistingUser = res?.isCRExistingUser;
      setIsCRExistingUserState(isCRExistingUser);

      if (res?.showResumeEmailModal === true && !isCurrentResume.current) {
        setEmailSentModal();
        showEmailSentModal();
      } else if (res?.isReturningUser === false) {
        if (res?.potentialParticipantId) {
          setCookie('bx_guest_ref', res?.potentialParticipantId, {
            expires: getCookieExpiryTime(
              siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
            ),
            secure: true,
          });
          dispatch(addpotentialParticipantId(res?.potentialParticipantId));
          updatePpidRef.current = true;
        }
        if (res?.browserId) {
          const cookieName = 'bid_' + process.env.NEXT_PUBLIC_CDP_CLIENT_KEY;
          setCookie(cookieName, res?.browserId, {
            secure: true,
            expires: getCookieExpiryTime(
              siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
            ),
          });
        }
        await saveDataToDBAndCdp(data);
      } else {
        if (res?.showCustomErrorMessageModel) {
          // show modal popup
          setCustomErrorModal();
          showCustomErrorModal();
        } else if (res?.showPatientExistModel) {
          // show modal popup
          setPatientExistModal();
          showPatientExistErrorModal();
        }
        return;
      }
    } catch (_e) {
      setIsLoading(false);
      return;
    }
  };

  const onSubmit = async (data: any) => {
    retryCount.current = 0;
    let isResumeEmailCheck = false;
    let isReturnCheck = false;
    let isJourney3 = false;
    if (journeyType === JOURNEYS.JOURNEY_03) {
      if (isDifferentBrowserResumeJourneyEnabled(siteSettings)) {
        isResumeEmailCheck = true;
      }
      isJourney3 = true;
    }
    if (journeyType === JOURNEYS.JOURNEY_02) {
      if (isDifferentBrowserResumeJourneyEnabled(siteSettings)) {
        isResumeEmailCheck = true;
      }
      isReturnCheck = true;
    }
    if (journeyType === JOURNEYS.JOURNEY_01) {
      isResumeEmailCheck = false;
      isReturnCheck = true;
    }

    const patientLocation = getLatestAutoCompleteLocationInfo()[USER_TYPE.PATIENT];
    const hasCoordinates = Boolean(patientLocation?.lat && patientLocation?.lng);
    const languageCode = selectedLanguage?.languageCode?.split('-')[0].toLowerCase() || 'en';
    const stateName =
      languageCode !== 'en' ? getTranslatedStateName(stateList, data?.State) : data?.State;

    const geocodeTask = !hasCoordinates
      ? getLatLongFromAddressOnSubmit(
          data?.Address,
          data?.City,
          stateName,
          data?.Zipcode,
          getTerritoryCountryCode(stateList, data?.State) || selectedLanguage?.countryISO2 || 'US',
          languageCode
        )
      : Promise.resolve();

    await Promise.all([
      geocodeTask,
      performReturningUserCheckOnSubmit(data, isResumeEmailCheck, isReturnCheck, isJourney3),
    ]);
  };

  return (
    <ContactInfoContextProvider
      formHandlerObject={formHandlerObject}
      userToggleableSmsFieldNames={userToggleableSmsFieldNames}
      contactEmailDomainsList={contactEmailDomainsList}
    >
      <ContactInfo onSubmit={onSubmit} fields={props?.fields} isLoading={isLoading} />
    </ContactInfoContextProvider>
  );
};

export const getStaticProps: GetStaticComponentProps = async (_rendering, layoutData) => {
  //TODO: Need to check if we can have this as commom code, can be used for other contact forms
  const context = layoutData?.sitecore?.context as ExtenedLayoutServiceContextInterface;
  const language = context?.language || process.env.DEFAULT_LANGUAGE || 'en';
  const countryId = context?.siteSettings?.country?.id as string;
  const rootPath =
    context?.siteSettings?.conditionSource?.id || '{8ABC0FE8-331F-401F-95BC-BAB80811FCE4}';

  if (process.env.JSS_MODE === constants.JSS_MODE.DISCONNECTED) {
    return null;
  }
  const getAllContactFormStatesResponse = await getAllContactFormStates(
    language,
    (_rendering as any)?.dataSource
  );
  const stateList =
    getAllContactFormStatesResponse?.length > 0
      ? getAllContactFormStatesResponse
      : await getAllStates(language, countryId);
  const timeZoneList = await getAllTimeZones(language, countryId);
  const COIList = await fetchConditionOfInterest(language, rootPath);
  const contactEmailDomainsList = await getContactEmailDomainsListForContactInfo(
    language,
    context?.siteSettings
  );

  return {
    stateList,
    timeZoneList,
    COIList,
    contactEmailDomainsList,
  };
};
export default AdultContactInfo;
